import api from "@modules/api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import tradeInQueryKeys from "@modules/trade/types/tradeInQueryKeys";

type Request = {
  source: string;
  tradeInToken: string;
};

const postClaimIcoForAuthenticatedUserMutation = async ({
  source,
  tradeInToken,
}: Request) => {
  return api.rawPost(`api/purchases/ico/${source}/claim`, {
    headers: {
      authorization: `Bearer ${tradeInToken}`,
    },
  });
};

export default function useClaimIcoForAuthenticatedUserMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postClaimIcoForAuthenticatedUserMutation,
    onSuccess: (_, { tradeInToken }) => {
      queryClient.invalidateQueries({
        queryKey: tradeInQueryKeys.appraisalByToken(tradeInToken),
      });
    },
  });
}
